import { getEnumValueLabel, TranslateLike } from './helper';

const COUPON_TYPE_KEY_MAP = {
  1: 'coupon.type.store',
  2: 'coupon.type.product',
} as const;

const COUPON_STATUS_KEY_MAP = {
  ALL: 'coupon.status.all',
  ONGOING: 'coupon.status.ongoing',
  SCHEDULED: 'coupon.status.notStarted',
  ENDED: 'coupon.status.expired',
  SUSPENDED: 'coupon.status.suspended',
} as const;

export const getCouponTypeLabel = (t: TranslateLike, type?: 1 | 2) =>
  getEnumValueLabel(t, type, COUPON_TYPE_KEY_MAP);

export const getCouponStatusLabel = (
  t: TranslateLike,
  status?: 'ALL' | 'ONGOING' | 'SCHEDULED' | 'ENDED' | 'SUSPENDED',
) => getEnumValueLabel(t, status, COUPON_STATUS_KEY_MAP);
